import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

function MediaQuerySm(props) {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.only('sm'));
  if(matches) {
    return props.content
  } else {
    return null
  }
}

export default MediaQuerySm;